import React, { useState } from "react";
import Header from "../../Layout/Header";
import Footer from "../../Layout/Footer";
import PatientHeader from "../../Layout/PatientHeader";
const Profile = () => {
  const [height, setHeight] = useState(0);
  return (
    <div>
      <Header setHeight={setHeight} />
      <div
        className="profile_crumb"
        style={{ height: height + 10 + "px" }}
      ></div>
      <div className="profile_page pb-5">
        <section className="py-5">
          <PatientHeader title="My Profile" />
          <div className="container px-5 mt-5">
            <div className="w-70 bg-white shadow rounded_outer py-5 mx-auto px-5">
              <div className="pb-3 px-5 pt-3">
                
                <div className="d-flex justify-content-center align-items-center pt-3 pb-2">
                  <div className="profile_pic_container">
                    <img
                      src="https://www.docterio.com/static/profile_pics/acaf484db6c7bdd3.png"
                      alt=""
                    />
                    <div className="icon_edit">
                      <svg 
                        version="1.1"
                        id="Capa_1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 383.947 383.947"
                        xmlSpace="preserve"
                      >
                        <g>
                          <g>
                            <g>
                              <polygon points="0,303.947 0,383.947 80,383.947 316.053,147.893 236.053,67.893" />
                              <path d="M377.707,56.053L327.893,6.24c-8.32-8.32-21.867-8.32-30.187,0l-39.04,39.04l80,80l39.04-39.04 C386.027,77.92,386.027,64.373,377.707,56.053z" />
                            </g>
                          </g>
                        </g>
                      </svg>
                    </div>
                  </div>
                </div>
                <h3 className="text-center py-5 font-weight-bold">
                  Edit your personal information
                </h3>

                <div className="row">
                    <div className="col-lg-6 pb-3">
                      <div className="form_input">
                        <input
                          placeholder="First Name"
                          className="form-control px-3 py-2 h-auto"
                          type="text"
                          id="name"
                          required
                        />
                        <label className="ml-3" htmlFor="name">
                          First Name
                        </label>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form_input">
                        <input
                          className="form-control px-3 py-2 h-auto"
                          placeholder="Last Name"
                          type="text"
                          id="surname"
                          required
                        />
                        <label className="ml-3" htmlFor="surname">
                          Last Name
                        </label>
                      </div>
                    </div>
                </div>
                  <div className="row pt-3">
                    <div className="col-lg-12 pb-5">
                      <div className="form_input">
                        <input
                          className="form-control px-3 py-2 h-auto"
                          placeholder="Age"
                          type="text"
                          id="age"
                          required
                        />
                        <label className="ml-3" htmlFor="age">
                          Age
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="pb-5 text-center">
                    <button className="btn btn-theme text-uppercase font-smaller py-2 px-3 btn-dark">
                      {" "}
                      Update profile{" "}
                    </button>
                  </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default Profile;
